import { COLOR_DOWNRIVER, COLOR_WELL_READ } from "./styles";

export const getStagingColor = () => {
  let hostNames = window.location.hostname.split(".");
  if(hostNames[0] === "stagingadmin" || hostNames[0] === "localhost") {
   return COLOR_WELL_READ;
  }
  return COLOR_DOWNRIVER;
};